<template>
<div class="modal-wrapper" v-if="show" @click.prevent.stop="close()">
    <div class="modal" @click.prevent.stop>
        <a class="close" title="Close" @click.prevent.stop="close()"><i class="far fa-times"></i></a>
        <slot></slot>
    </div>
</div>
</template>
<script>
export default {
    props: ['show'],
    methods: {
        close() {
            this.$emit('close')
        }
    }
}
</script>


// WEBPACK FOOTER //
// assets/js/components/Modal.vue